import { Routes } from '@angular/router';
import { LoginPageComponent } from './login-page.component';
import { LogoutPageComponent } from './logout-page.component';

export const authenticationRoutes: Routes = [
    {
        path: 'login',
        data: {title: 'Labcorp Portal Login'},
        component: LoginPageComponent
    },
    {
        path: 'logout',
        data: {title: 'Labcorp Portal Logout'},
        component: LogoutPageComponent
    }
];